(() => {
  angular
    .module('gm.common.directives')
    .directive('btgActionButton', btgActionButtonDirective);

  /**
   * Toggle button styles
   *
   * @param  {Object} $parse
   * @param  {Object} $timeout
   * @return {Object}
   */
  function btgActionButtonDirective(
    $parse,
    $timeout
  ) {
    'ngInject';

    return {
      restrict: 'A',

      compile(_element, attrs) {
        const fn = $parse(attrs.btgActionButton, null, true);

        return (scope, element) => {
          element.on('click', (event) => {
            $timeout(() => {
              const result = fn(scope, { $event: event });

              if (result && angular.isFunction(result.finally)) {
                element.addClass('loading-button');
                element.prop('disabled', true);

                result.finally(() => {
                  element.removeClass('loading-button');
                  element.prop('disabled', false);
                });
              }
            });
          });
        };
      }
    };
  }
})();
